import React from "react";

export const LegalLinks: React.FC = () => (
  <nav className="flex justify-center gap-3 text-fg-muted-regular-small">
    {[
      ["Terms", "terms"],
      ["Privacy", "privacy"],
    ].map(([label, path]) => (
      <a
        key={path}
        href={`https://mycorr.app/${path}/`}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-accent hover:underline"
      >
        {label}
      </a>
    ))}
  </nav>
);
